import { fork } from "redux-saga/effects";
import tiWatcher from "../../modules/TI/saga/TiWatcher";

export default function* rootSaga() {
  yield fork(tiWatcher);
}
